import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthLayout } from './AuthLayout';
import { DOWNLOAD_RECORD_KEY } from '../vetting/lodgement-card';

export function LogoutPage(): JSX.Element {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/vetting/auth/logout', {
      method: 'POST',
      credentials: 'include',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .catch(() => {
        // Continue regardless — cookie will expire naturally
      })
      .finally(() => {
        // Storage that is missing or throws must not strand the page on
        // "Signing out...". The registrar card's download record (applicant
        // ids and times) goes with the session (cca-omhx, Lazo Low 2).
        try {
          localStorage.removeItem('auth_email');
          localStorage.removeItem(DOWNLOAD_RECORD_KEY);
        } catch {
          // Storage unavailable — carry on signing out.
        }
        setLoading(false);
      });
  }, []);

  return (
    <AuthLayout>
      <div className="mx-auto max-w-sm">
        <div className="panel space-y-4 text-center">
          <h2 className="mb-3 text-lg font-semibold text-ccaanz-black">
            {loading ? 'Signing out...' : "You're all set"}
          </h2>
          <p className="mb-6 text-sm text-ccaanz-grey">
            {loading
              ? "We're logging you out of the Vetting Portal."
              : 'You have been signed out securely.'}
          </p>

          {!loading && (
            <button onClick={() => navigate('/auth/login')} className="btn btn-primary">
              Sign In Again
            </button>
          )}
        </div>
      </div>
    </AuthLayout>
  );
}
